import {useEffect, useState} from 'react';
import {useAuth} from '../../context/AuthContext';
import {controlApi} from './ChatControlCenter';
import {playChatSound} from '../../lib/chatNotify';

export default function useHumanQueue() {
  const {user} = useAuth();
  const [queue, setQueue] = useState({items:[],total:0});
  useEffect(()=>{
    if (!user?.id) return undefined;
    let alive=true, pending=false, forbidden=false;
    const key=`office-human-queue:${user.id}`;
    let seen=new Set();
    try {seen=new Set(JSON.parse(sessionStorage.getItem(key)||'[]'));} catch { /* memory only */ }
    const poll=async()=>{
      if (!alive||pending||forbidden||document.hidden) return;
      pending=true;
      try {
        const data=await controlApi('get','/conversations?mode=waiting');
        if (!alive || !Array.isArray(data?.items) || !Number.isFinite(data?.total)) return;
        setQueue(data);
        let fresh=0;
        for (const row of data.items) {
          const id=row.chatbot_handoff_event||row.id;
          if (!seen.has(id)) {seen.add(id);fresh+=1;}
        }
        if (fresh) {
          // Queue remains visible in the bell. Do not use the global toast
          // adapter: Office renders informational toasts as blocking modals.
          playChatSound('alert');
          try {sessionStorage.setItem(key,JSON.stringify([...seen].slice(-1000)));} catch { /* memory only */ }
        }
      } catch(e) {if ([401,403,404].includes(e.response?.status)) forbidden=true;}
      finally {pending=false;}
    };
    setQueue({items:[],total:0}); poll();
    const interval=setInterval(poll,30000);
    document.addEventListener('visibilitychange',poll);
    return ()=>{alive=false;clearInterval(interval);document.removeEventListener('visibilitychange',poll);};
  },[user?.id]);
  return queue;
}
